import { render, staticRenderFns } from "./KtbFastPayFail.vue?vue&type=template&id=6faa5d11&scoped=true"
import script from "./KtbFastPayFail.vue?vue&type=script&lang=js"
export * from "./KtbFastPayFail.vue?vue&type=script&lang=js"
import style0 from "./KtbFastPayFail.vue?vue&type=style&index=0&id=6faa5d11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6faa5d11",
  null
  
)

export default component.exports